import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

//Libraries
import { Provider } from 'react-redux';
// import { PersistGate } from 'redux-persist/integration/react';
// import { persistStore } from 'redux-persist';

//Components
import { store } from './redux/store';

// let persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
